export default "__VITE_ASSET__BfX7vuaF__"